import { getConfig, URLS } from '@constants';

import { EApiUpstream } from '@enums';

import { getCgiUrl } from '@utils';

import { BaseApi } from '../BaseApi';

import { IApiAjaxResponse, IUser } from '@interfaces';

/* eslint-disable @typescript-eslint/naming-convention */
export interface IBillingInfoResponse {
	app_id?: string;
	mailiki_price?: string;
	service_name?: string;
	mobile_canvas?: string;
}

export interface IBillingInfo {
	appId: string;
	price: number;
	serviceName: string;
	isHybrid?: boolean;
	issuer_id?: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

export enum EBillingInfoResponseResult {
	SUCCESS = 'OK',
	ERROR = 'ERR',
	PENDING = 'WAIT'
}

export type BillingInfoResponseType = [EBillingInfoResponseResult, { data: IBillingInfoResponse }]

export interface IBillingInfoResult {
	status: EBillingInfoResponseResult;
}

export class BillingApi extends BaseApi {

	async getStatByIssuerId(currentUser: IUser, issuerId: string): Promise<IBillingInfoResult> {
		if (getConfig().payment.isUseIssuerid) {
			const url = getCgiUrl({
				url: URLS.AJAX,
				args: {
					/* eslint-disable @typescript-eslint/naming-convention */
					issuer_id: issuerId,
					no_refund: 0,
				},
				params: {
					func_name: 'billing.getStatByIssuerId',
					/* eslint-enable @typescript-eslint/naming-convention */
				},
				user: currentUser,
			});
			const billingResponse: IApiAjaxResponse<{res: string}> = await this.get({
				url,
				upstream: EApiUpstream.MPOP,
			});
			const status = billingResponse.data[2].res;
			const correctResponce = status === EBillingInfoResponseResult.SUCCESS ||
				status === EBillingInfoResponseResult.ERROR ||
				status === EBillingInfoResponseResult.PENDING;

			return {
				status: correctResponce
					? billingResponse.data[2].res as EBillingInfoResponseResult
					: EBillingInfoResponseResult.ERROR,
			};
		} else {
			const promise: Promise<EBillingInfoResponseResult> = new Promise((resolve) => {
				setTimeout(() => {
					resolve(EBillingInfoResponseResult.SUCCESS);
				}, 3000);
			});
			const status = await promise;

			return { status };
		}
	}

}
